import httpClient from '../http';
import { API_ENDPOINTS } from '../config';
export const tutorialsApi = {
    list: (params = {}) => httpClient.get(API_ENDPOINTS.TUTORIALS.LIST, { params }),
    detail: (id) => httpClient.get(`${API_ENDPOINTS.TUTORIALS.DETAIL}&id=${id}`),
    create: (data) => httpClient.post(API_ENDPOINTS.TUTORIALS.CREATE, data),
    update: (data) => httpClient.put(API_ENDPOINTS.TUTORIALS.UPDATE, data),
    delete: (id) => httpClient.delete(API_ENDPOINTS.TUTORIALS.DELETE, { data: { id } }),
    publish: (id) => httpClient.put(API_ENDPOINTS.TUTORIALS.PUBLISH, { id }),
    unpublish: (id) => httpClient.put(API_ENDPOINTS.TUTORIALS.UNPUBLISH, { id }),
    pin: (id) => httpClient.put(API_ENDPOINTS.TUTORIALS.PIN, { id }),
    unpin: (id) => httpClient.put(API_ENDPOINTS.TUTORIALS.UNPIN, { id }),
    batchPin: (ids, is_top = 1) => httpClient.put(API_ENDPOINTS.TUTORIALS.BATCH_PIN, { ids, is_top }),
    updateOrder: (ordered_ids) => httpClient.put(API_ENDPOINTS.TUTORIALS.UPDATE_ORDER, { ordered_ids }),
    categories: () => httpClient.get(API_ENDPOINTS.TUTORIALS.CATEGORIES), // legacy aggregated categories by name
    uploadImage: (file) => {
        const formData = new FormData();
        formData.append('file', file);
        return httpClient.post(API_ENDPOINTS.TUTORIALS.UPLOAD_IMAGE, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    }
};
